/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // =============================================
  // Size Format Toggle
  // =============================================
  const STORAGE_KEY = 'preferredSizeFormat';

  function initSizeFormatToggle() {
    const sizing = window.productSizing;
    const select = document.getElementById('size-format-select');

    if (!select || !sizing) return;

    // Restore saved preference, default to EU
    const saved = localStorage.getItem(STORAGE_KEY) || 'mens';
    select.value = saved;
    applyFormat(saved);

    // Listen for changes
    select.addEventListener('change', function () {
      const format = this.value;
      localStorage.setItem(STORAGE_KEY, format);
      applyFormat(format);
    });

    function applyFormat(format) {
      const labels = sizing[format];
      if (!labels) return;

      const sizeItems = document.querySelectorAll('[data-size-btn]');
      sizeItems.forEach(function (item) {
        const index = parseInt(item.getAttribute('data-index'), 10);
        if (labels[index] !== undefined) {
          item.textContent = labels[index];
        }
      });
    }
  }

  // Delay to let Broadcast's JS initialise first
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(initSizeFormatToggle, 300);
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
